import * as Yup from 'yup';
import editTipoNOvedadFormModel from './editTipoNovedadFormModel';

const {
  formField: { e_name },
} = editTipoNOvedadFormModel;

export default [
  Yup.object().shape({
    [e_name.name]: Yup.string().required(`${e_name.requiredErrorMsg}`),
  }),
];
